

{
  "familyId": "TAA-ARGUMENTATIE",
  "questions": [
    {
      "id": "TAA-ARGUMENTATIE-001",
      "familyId": "TAA-ARGUMENTATIE",
      "module": "Taalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_argumentatie",
      "questionType": "multiple_choice",
      "question": "Lees: 'Schoolzwemmen moet weer terugkomen. Veel kinderen kunnen niet zwemmen. Vorig jaar verdronken in Nederland 12 kinderen. Bovendien is zwemmen gezond.' Welke zin is GEEN argument voor het standpunt?",
      "options": [
        "Schoolzwemmen moet weer terugkomen.",
        "Veel kinderen kunnen niet zwemmen.",
        "Vorig jaar verdronken in Nederland 12 kinderen.",
        "Bovendien is zwemmen gezond."
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Standpunt vs argument",
            "content": "Het standpunt is wat de schrijver vindt. Argumenten zijn de redenen waarom. 'Schoolzwemmen moet terugkomen' is wat de schrijver vindt — dat is het standpunt, geen argument.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "argumentatie_standpunt_isoleren",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Schoolzwemmen moet weer terugkomen' is het standpunt — wat de schrijver vindt. De drie andere zinnen zijn argumenten: ze geven redenen waarom schoolzwemmen terug moet komen.",
        "solutionSteps": [
          "Standpunt = wat de schrijver vindt",
          "Argument = waarom de schrijver dat vindt",
          "'Moet terugkomen' = standpunt"
        ],
        "distractorExplanations": {
          "0": "Goed! Dit is het standpunt, niet een argument.",
          "1": "'Veel kinderen kunnen niet zwemmen' is wél een argument — het geeft een reden waarom schoolzwemmen nodig is.",
          "2": "'12 kinderen verdronken' is wél een argument — het is zelfs een sterk argument met een feit.",
          "3": "'Zwemmen is gezond' is wél een argument — het geeft een extra reden."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.arg.feit.als.argument", "label": "Verwart een feit-argument met het standpunt", "optionIndex": 1 },
          { "id": "taa.arg.feit.als.argument", "label": "Denkt dat alleen feiten standpunt kunnen zijn", "optionIndex": 2 },
          { "id": "taa.arg.mening.als.argument", "label": "Verwart bijargument met standpunt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ARGUMENTATIE-002",
      "familyId": "TAA-ARGUMENTATIE",
      "module": "Taalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_argumentatie",
      "questionType": "multiple_choice",
      "question": "Lees: 'Mobieltjes horen niet thuis op school. Ze leiden af tijdens de les, want kinderen kijken steeds op hun scherm. Ook pesten gebeurt vaak via de telefoon. Sommige kinderen vinden dat trouwens niet erg. Bovendien gaan cijfers omhoog als telefoons in een kluisje gaan.' Hoeveel argumenten ondersteunen het standpunt?",
      "options": ["3", "4", "2", "1"],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Alleen ondersteunende argumenten tellen",
            "content": "Tel alleen zinnen die het standpunt ondersteunen. Argumenten: 1) afleiden, 2) pesten, 3) cijfers omhoog. 'Sommige kinderen vinden dat niet erg' pleit niet vóór, dat is eerder een tegenargument.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "argumentatie_tellen_met_afleider",
      "variantIndex": 2,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Er zijn 3 argumenten vóór het standpunt: 1) telefoons leiden af, 2) pesten gebeurt via telefoon, 3) cijfers gaan omhoog. De zin 'Sommige kinderen vinden dat niet erg' is een tegenargument, niet een ondersteunend argument.",
        "solutionSteps": [
          "Standpunt: mobieltjes horen niet op school",
          "Argument 1: ze leiden af",
          "Argument 2: pesten via telefoon",
          "Argument 3: cijfers omhoog",
          "Afleider: 'sommige kinderen vinden dat niet erg' = tegenargument"
        ],
        "distractorExplanations": {
          "0": "Goed! Drie ondersteunende argumenten. De zin over 'niet erg vinden' is een tegenargument.",
          "1": "Je telde 4 — maar 'sommige kinderen vinden dat niet erg' pleit niet vóór het standpunt. Dat is een tegenargument.",
          "2": "Je telde te weinig. Er zijn 3 ondersteunende redenen: afleiden, pesten, cijfers omhoog.",
          "3": "Je telde slechts 1 — maar er staan meerdere redenen vóór het standpunt."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.arg.standpunt.als.argument", "label": "Telt tegenargument mee als ondersteunend argument", "optionIndex": 1 },
          { "id": "taa.arg.tellen.te.weinig", "label": "Mist één van de drie argumenten", "optionIndex": 2 },
          { "id": "taa.arg.geen.argument.herkend", "label": "Herkent slechts 1 argument", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ARGUMENTATIE-003",
      "familyId": "TAA-ARGUMENTATIE",
      "module": "Taalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_argumentatie",
      "questionType": "multiple_choice",
      "question": "Welk argument is het sterkst om te bewijzen dat huisdieren goed zijn voor kinderen?",
      "options": [
        "Onderzoek toont aan dat kinderen met huisdieren minder stress hebben.",
        "Ik vind huisdieren leuk.",
        "Mijn buurman heeft ook een hond.",
        "Huisdieren zijn schattig."
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Sterk vs zwak argument",
            "content": "Een sterk argument is gebaseerd op feiten of onderzoek. Een zwak argument is gebaseerd op persoonlijke mening of een enkel voorbeeld.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "argumentatie_sterk_zwak",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het sterkste argument verwijst naar onderzoek — dat is een feit, geen mening. De andere opties zijn persoonlijke meningen of losse voorbeelden.",
        "solutionSteps": [
          "Sterk: gebaseerd op onderzoek/feiten",
          "Zwak: persoonlijke mening of enkel voorbeeld"
        ],
        "distractorExplanations": {
          "0": "Goed! Onderzoek is het sterkste bewijs.",
          "1": "'Ik vind huisdieren leuk' is een persoonlijke mening, geen bewijs. Onthoud: mening ≠ argument.",
          "2": "'Mijn buurman heeft een hond' is een enkel voorbeeld, geen bewijs. Onthoud: één voorbeeld bewijst niets.",
          "3": "'Schattig' is een mening over uiterlijk, geen bewijs voor gezondheid. Onthoud: het argument moet het standpunt ondersteunen."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.arg.mening.als.sterk", "label": "Denkt dat persoonlijke mening een sterk argument is", "optionIndex": 1 },
          { "id": "taa.arg.voorbeeld.als.sterk", "label": "Denkt dat een enkel voorbeeld een sterk argument is", "optionIndex": 2 },
          { "id": "taa.arg.uiterlijk.als.sterk", "label": "Verwart mening over uiterlijk met sterk argument", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ARGUMENTATIE-004",
      "familyId": "TAA-ARGUMENTATIE",
      "module": "Taalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_argumentatie",
      "questionType": "multiple_choice",
      "question": "Lees: 'Scholen moeten gezondere lunches aanbieden. Kinderen eten te veel suiker. Sommige ouders zeggen dat het te duur wordt. Maar de kosten dalen als scholen samen inkopen.' Welke zin is het tegenargument?",
      "options": [
        "Sommige ouders zeggen dat het te duur wordt.",
        "Scholen moeten gezondere lunches aanbieden.",
        "Kinderen eten te veel suiker.",
        "Maar de kosten dalen als scholen samen inkopen."
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tegenargument herkennen",
            "content": "Een tegenargument pleit TEGEN het standpunt. Zoek de zin die een bezwaar of nadeel noemt. 'Te duur' is een bezwaar tegen gezondere lunches — dat is het tegenargument. De daaropvolgende zin met 'maar' is de weerlegging.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "argumentatie_tegenargument_lokaliseren",
      "variantIndex": 4,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Het tegenargument is 'Sommige ouders zeggen dat het te duur wordt'. Dit pleit tegen het standpunt (kosten als bezwaar). De zin met 'maar' erna is de weerlegging — die toont dat het bezwaar niet houdt.",
        "solutionSteps": [
          "Standpunt: gezondere lunches",
          "Argument: kinderen eten te veel suiker",
          "Tegenargument: te duur (bezwaar)",
          "Weerlegging: kosten dalen door samen inkopen"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Te duur' is het bezwaar — dat is het tegenargument.",
          "1": "Dit is het standpunt, niet een tegenargument. Een tegenargument pleit ergens tegen.",
          "2": "Dit is een argument vóór het standpunt, niet een tegenargument.",
          "3": "Dit is de weerlegging van het tegenargument, niet het tegenargument zelf. De zin met 'maar' verzwakt het tegenargument juist."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.arg.argument.als.tegenargument", "label": "Verwart standpunt met tegenargument", "optionIndex": 1 },
          { "id": "taa.arg.argument.als.tegenargument", "label": "Verwart ondersteunend argument met tegenargument", "optionIndex": 2 },
          { "id": "taa.arg.samenvatting.als.tegenargument", "label": "Verwart weerlegging met tegenargument", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-ARGUMENTATIE-005",
      "familyId": "TAA-ARGUMENTATIE",
      "module": "Taalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_argumentatie",
      "questionType": "ordering",
      "question": "Een leerling schrijft een betoog over schooluniformen. Zet de fragmenten in de juiste volgorde van een sterk betoog.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Schooluniformen zouden verplicht moeten zijn op alle basisscholen.",
          "Uniformen verminderen pesten, zo bleek uit onderzoek van de Universiteit Utrecht.",
          "Bovendien besparen ouders gemiddeld €400 per jaar aan kleding.",
          "Sommige ouders vinden uniformen saai, maar saaiheid weegt niet op tegen minder pesten en lagere kosten.",
          "Daarom: verplichte schooluniformen maken de school veiliger en goedkoper."
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Opbouw van een sterk betoog",
            "content": "Begin met je standpunt. Geef daarna je sterkste argumenten (vaak: feit/onderzoek eerst, daarna ondersteunende argumenten). Bespreek dan een tegenargument met weerlegging. Sluit af met een conclusie die het standpunt herhaalt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "argumentatie_opbouw_analyseren",
      "variantIndex": 5,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een sterk betoog: 1) standpunt vooraan, 2) sterkste argument (onderzoek) eerst, 3) ondersteunend argument (kosten), 4) tegenargument + weerlegging, 5) conclusie. Het tegenargument moet vóór de conclusie staan, want de conclusie sluit het betoog af.",
        "solutionSteps": [
          "1. Standpunt",
          "2. Sterkste argument (onderzoek)",
          "3. Ondersteunend argument (kosten)",
          "4. Tegenargument + weerlegging",
          "5. Conclusie"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.arg.samenvatting.als.tegenargument", "label": "Plaatst conclusie/samenvatting vóór tegenargument" },
          { "id": "taa.arg.argument.als.tegenargument", "label": "Verwart positie van argument en tegenargument" }
        ]
      }
    },
    {
      "id": "TAA-ARGUMENTATIE-006",
      "familyId": "TAA-ARGUMENTATIE",
      "module": "Taalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_argumentatie",
      "questionType": "true_false_series",
      "question": "Lees het fragment en beoordeel elke uitspraak. Fragment: 'Computerspellen zijn slecht voor kinderen. Onderzoekers van Harvard vinden dat lange spelduur het slaappatroon verstoort. Mijn nichtje speelt elke dag drie uur en heeft moeite met opletten. Sommige spellen leren juist samenwerking, maar de risico's wegen zwaarder.'",
      "data": {
        "statements": [
          { "text": "Het Harvard-onderzoek is een sterker argument dan het voorbeeld van het nichtje.", "isTrue": true, "explanation": "Onderzoek is gebaseerd op veel mensen en wetenschappelijke methode. Een voorbeeld van één persoon (nichtje) is te beperkt om als bewijs te dienen." },
          { "text": "'Sommige spellen leren samenwerking' is in dit fragment een ondersteunend argument.", "isTrue": false, "explanation": "Dit is een tegenargument — het pleit TEGEN het standpunt 'spellen zijn slecht'. Het wordt direct erna weerlegd met 'maar de risico's wegen zwaarder'." },
          { "text": "Het voorbeeld van het nichtje verzwakt het betoog omdat één persoon geen bewijs is.", "isTrue": true, "explanation": "Correct. Een enkel voorbeeld is een zwak argument. Het betoog zou sterker zijn met alleen het onderzoek." },
          { "text": "Het fragment bevat geen weerlegging van het tegenargument.", "isTrue": false, "explanation": "De zin 'maar de risico's wegen zwaarder' is de weerlegging — die laat zien dat het tegenargument minder belangrijk is." }
        ]
      },
      "correctAnswer": "true,false,true,false",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Analyse van argumenten",
            "content": "Sterk argument = onderzoek/feiten over veel mensen. Zwak argument = persoonlijke ervaring of één voorbeeld. Tegenargument = pleit tegen standpunt. Weerlegging = verzwakt het tegenargument.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "argumentatie_evalueren_serie",
      "variantIndex": 6,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.arg.voorbeeld.als.sterk", "label": "Beschouwt enkel voorbeeld als sterk argument" },
          { "id": "taa.arg.argument.als.tegenargument", "label": "Verwart tegenargument met ondersteunend argument" },
          { "id": "taa.arg.samenvatting.als.tegenargument", "label": "Mist herkenning van weerlegging" }
        ]
      },
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Sterk argument = wetenschappelijk onderzoek. Zwak argument = persoonlijk voorbeeld (nichtje). Het samenwerkings-argument pleit tegen het standpunt = tegenargument. 'Maar de risico's wegen zwaarder' = weerlegging."
      }
    }
  ]
}

